import { render, staticRenderFns } from "./GroupsDelete.vue?vue&type=template&id=c79bfe6c&scoped=true"
import script from "./GroupsDelete.vue?vue&type=script&lang=js"
export * from "./GroupsDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79bfe6c",
  null
  
)

export default component.exports